import { forwardRef, useState, useRef, useImperativeHandle } from "react"
import SuggestedContactDropdown from "components/admin/RegistrationContact/suggested_contact_dropdown"
import AccountCenterSearch from "components/admin/account_center_search/account_center_search"
import { number, string, arrayOf, shape, func, bool } from "prop-types"
import { css } from "@emotion/core"

const styles = {
  contactSearchWrapper: css`
    z-index: 1;
    & .search {
      flex: 1;
    }
  `,
  contactSearchBar: css`
    min-width: 120px;
    width: 100%;
    padding: 6px 8px !important;
  `
}

const EditContact = forwardRef(
  (
    {
      onCancel,
      onSelect,
      loading,
      helpText,
      suggestedPeople = [],
      responsiblePerson,
      isSaving = false
    },
    ref
  ) => {
    const accountCenterSearch = useRef(null)
    const suggestedContact = useRef(null)

    const [isSearching, setIsSearching] = useState(false)

    useImperativeHandle(ref, () => ({
      clearSelection() {
        accountCenterSearch.current.clearSelection()
      }
    }))

    const handleSelectSearch = () => {
      setIsSearching(true)
    }

    const handleSearchSelection = person => {
      setIsSearching(false)
      onSelect(person)
    }

    const handleSearchCancel = () => {
      setIsSearching(false)
      suggestedContact.current.setSelection(
        responsiblePerson?.personId ??
          responsiblePerson?.account_center_id ??
          responsiblePerson?.accountCenterId
      )
      onCancel()
    }

    const contactAvatarUrl =
      responsiblePerson?.avatarUrl ??
      responsiblePerson?.avatar_url ??
      responsiblePerson?.demographic_avatar_url ??
      "/static/no_photo_thumbnail_adult.png?g=96x96%23"

    return (
      <div>
        <div className="d-f ai-c d-f@print ai-c@print p-r">
          <img
            src={contactAvatarUrl}
            alt="generic avatar"
            className="w-6 h-6 circle"
            css={{ "@media (max-width: 599px)": { display: "none" } }}
          />
          {suggestedPeople.length > 0 && (
            <div className="f-1 ml-1">
              <SuggestedContactDropdown
                selectedContact={responsiblePerson}
                suggestedPeople={suggestedPeople}
                onSelect={onSelect}
                onSearch={handleSelectSearch}
                ref={suggestedContact}
                disabled={isSaving}
              />
            </div>
          )}
          {(!responsiblePerson || isSearching) && (
            <div className="ml-1@sm d-f ai-c f-1" css={styles.contactSearchWrapper}>
              <AccountCenterSearch
                inputProps={{
                  placeholder: "Search",
                  disabled: loading,
                  css: styles.contactSearchBar
                }}
                onSelect={handleSearchSelection}
                ref={accountCenterSearch}
              />
              {onCancel && responsiblePerson && (
                <button onClick={handleSearchCancel} className="ml-1 quiet-btn btn2">
                  Cancel
                </button>
              )}
            </div>
          )}
        </div>
        <div
          className="mt-4p font-size-4 c-secondary"
          css={{ "@media (min-width: 600px)": { paddingLeft: 58 } }}
        >
          {helpText || "All correspondence for this registration will be sent to this person"}
        </div>
      </div>
    )
  }
)

EditContact.displayName = "EditContact"

EditContact.propTypes = {
  onCancel: func,
  onSelect: func,
  loading: bool,
  helpText: string,
  suggestedPeople: arrayOf(
    shape({
      name: string,
      id: number
    })
  ),
  responsiblePerson: shape({ avatarUrl: string }),
  isSaving: bool
}

export default EditContact
